module.exports = __webpack_public_path__ + "static/media/pasar-itv.f06f8fb0.png";